import axios from "axios";
import Config from "../../config";

const actionListaCanaisPorCliente = (clienteId) => {
    
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/clientes/cliente/canais/${clienteId}/lista`
    });
};

export default actionListaCanaisPorCliente;
